import { Component, computed, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { COMMON_IMPORTS } from '../../common-imports';
import { ShowUserFacade } from '../../../../Facades/Intune/show-user.facade';
import { ShowDeviceFacade } from '../../../../Facades/Intune/show-device.facade';
import { AvBreadcrumbItem } from '../../Interfaces/av-breadcrumb.interface';

@Component({
  selector: 'av-breadcrumb',
  standalone: true,
  imports: [COMMON_IMPORTS, RouterLink],
  templateUrl: './av-breadcrumb.component.html',
  styleUrl: './av-breadcrumb.component.scss',
})
export class AvBreadcrumbComponent {
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _usersFacade = inject(ShowUserFacade, { optional: true });
  private _devicesFacade = inject(ShowDeviceFacade, { optional: true });

  readonly entityIsLoaded = computed(() => !!(this._usersFacade?.user() || this._devicesFacade?.device()));

  get items(): AvBreadcrumbItem[] {
    const segments = this._router.url.split('/').filter(Boolean);
    if (segments.length < 2) return [];

    const entity = segments[0];

    if (entity === 'users') {
      const id = segments[1];
      const titleKey = 'app.navigation.secondary_nav.title.users';
      const userName = this._usersFacade?.user()?.displayName ?? id;
      const childRoute = this._route.snapshot.firstChild;
      const childLabel = childRoute?.data?.['label'] as string | undefined;
      const childTitleKey = childLabel
        ? `app.navigation.secondary_nav.item.${childLabel}.title`
        : '';

      const result: AvBreadcrumbItem[] = [
        { label: titleKey, link: '/users' },
        { label: userName, link: `/users/${id}`, translate: false },
      ];
      if (childTitleKey) {
        result.push({ label: childTitleKey, link: undefined });
      }
      return result;
    }

    if (entity === 'devices') {
      const id = segments[1];
      const titleKey = 'app.navigation.secondary_nav.title.devices';
      const deviceName = this._devicesFacade?.device()?.intune?.displayDeviceName() ?? id;
      const childRoute = this._route.snapshot.firstChild;
      const childLabel = childRoute?.data?.['label'] as string | undefined;
      const childTitleKey = childLabel
        ? `app.navigation.secondary_nav.item.${childLabel}.title`
        : '';

      const result: AvBreadcrumbItem[] = [
        { label: titleKey, link: '/devices' },
        { label: deviceName, link: `/devices/${id}`, translate: false },
      ];
      if (childTitleKey) {
        result.push({ label: childTitleKey, link: undefined });
      }
      return result;
    }

    return [];
  }
}
